<template>
    <Popup
		v-model="popupConfig.showPopup"
		class="page-popup"
	>
		<div class="popup-content-box">
			<img class="popup-icon-qian" src="@/assets/img/icon_qian.png" alt="">
			<img class="popup-icon-hou" src="@/assets/img/icon_hou.png" alt="">
			<div class="popup-content-container">
				<div class="popup-content" :style="`width: ${popupConfig.width}`">
					<div class="popup-content-header">
						<div class="popup-content-header-txt" v-text="popupConfig.popupTitle"></div>
						<img class="popup-content-close hover-dom" src="@/assets/img/icon_guanbi.png" alt="" @click="handleClosePopup">
					</div>
					<div class="popup-content-area" v-html="popupConfig.popupContent" v-if="!popupConfig.slot" />
					<div class="popup-content-area" v-else>
						<slot></slot>
					</div>
					<div class="popup-content-bottom" v-if="popupConfig.submit">
						<ButtonVue :btnConfig="btnConfig" />
					</div>
				</div>
			</div>
		</div>
	</Popup>
</template>

<script>
import { Popup } from 'vant';

import ButtonVue from './Button.vue';

export default {
	name: 'Header',
	props: {
		popupConfig: {
			type: Object,
			default() {
				return {};
			},
		},
		submit: {
			type: Function,
			default: () => {},
		},
		cancel: {
			type: Function,
			default: () => {},
		},
	},
	components: {
		Popup,
		ButtonVue,
	},
	data() {
		return {
			showPopup: false,
			btnConfig: {
				type: 'green',
				txt: '确认',
			},
		};
	},
	created() {
	},
	mounted() {
	},
	methods: {
		handleShowPopup() {
			this.showPopup = true;
		},
		handleClosePopup() {
			this.handleCancel();
		},
		handleSubmit() {
			this.$props.popupConfig.showPopup = false;
			this.$emit('submit', {});
		},
		handleCancel() {
			this.$props.popupConfig.showPopup = false;
			this.$emit('cancel', {});
		},
	},
	watch: {
	},
};
</script>

<style scoped lang='scss'>
.page-popup {
	background: rgba(0, 0, 0, 0);
	overflow-y: visible;

	.popup-content-box {
		position: relative;
		.popup-header,.popup-bottom {
			display: block;
		}
	}
}

.app-pc {
	.popup-content-box {
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #FFF5D3;
		border-radius: 25px 25px 25px 25px;
		padding: 4px;
		box-sizing: border-box;

		.popup-icon {
			position: absolute;
			top: -70px;
			width: 120px;
			height: 80px;
		}
		.popup-icon-qian {
			position: absolute;
			left: calc(50% - 65px);
			top: -15px;
			width: 130px;
		}
		.popup-icon-hou {
			position: absolute;
			left: calc(50% - 34px);
			top: -66px;
			width: 68px;
			z-index: -1;
		}
		.popup-content-container {
			display: flex;
			justify-content: center;
			align-items: center;
			border-radius: 20px 20px 20px 20px;
			border: 3px solid #210000;
			background: #4cab7b;
			padding: 7px;
			box-sizing: border-box;
			overflow: hidden;
		}
		.popup-content {
			padding: 45px 40px 0;
			box-sizing: border-box;
			border-radius: 15px 15px 15px 15px;
			background-color: #FFF5D3;

			.popup-content-header {
				position: relative;
				display: flex;
				justify-content: center;
				align-items: center;

				.popup-content-header-txt {
					margin-top: -20px;
					font-weight: 600;
					font-size: 30px;
					color: #6B5A47;
					letter-spacing: 6px;
				}
				.popup-content-close {
					position: absolute;
					right: -18px;
					top: -30px;
				}
			}

			.popup-content-area {
				margin-top: 28px;

				max-height: calc(70vh - 175px);
				overflow-y: auto;

				color: #6b5a47;
				font-family: Microsoft YaHei;
				font-size: 16px;
				line-height: 24px;
				letter-spacing: 3px;
			}

			.popup-content-bottom {
				display: flex;
				justify-content: center;
			}
		}
	}
}
.app-mobile {
	.popup-content-box {
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #FFF5D3;
		border-radius: 13px 13px 13px 13px;
		padding: 2px;
		box-sizing: border-box;
		max-width: 80vw;

		.popup-icon {
			position: absolute;
			top: -30px;
			width: 60px;
		}
		.popup-icon-qian {
			position: absolute;
			left: calc(50% - 33px);
			top: -7.5px;
			width: 66px;
		}
		.popup-icon-hou {
			position: absolute;
			left: calc(50% - 17px);
			top: -33px;
			width: 34px;
			z-index: -1;
		}
		.popup-content-container {
			display: flex;
			justify-content: center;
			align-items: center;
			border-radius: 10px 10px 10px 10px;
			border: 1.5px solid #210000;
			background: #4cab7b;
			padding: 3px;
			box-sizing: border-box;
			overflow: hidden;
		}
		.popup-content {
			padding: 40px 13px 10px;
			box-sizing: border-box;
			border-radius: 7.5px 7.5px 7.5px 7.5px;
			background-color: #FFF5D3;

			.popup-content-header {
				position: relative;
				display: flex;
				justify-content: center;
				align-items: center;

				.popup-content-header-txt {
					margin-top: -25px;
					font-weight: 600;
					font-size: 16px;
					color: #6B5A47;
					letter-spacing: 3px;
				}
				.popup-content-close {
					position: absolute;
					right: -10px;
					top: -30px;
					height: 21px;
				}
			}

			.popup-content-area {
				margin-top: 14px;

				max-height: calc(70vh - 175px);
				overflow-y: auto;

				color: #6b5a47;
				font-family: Microsoft YaHei;
				font-size: 10px;
				line-height: 12px;
				letter-spacing: 2px;
			}

			.popup-content-bottom {
				display: flex;
				justify-content: center;
			}
		}
	}
}
</style>
